module.exports = __webpack_public_path__ + "img/ice.edb2150e.png";